var buttonSubmitp = $("#myButtonIpPing");
var buttonLoaderp = $("#flashipping");
var inputIpping = $("#ipping");

function ipPing(ipPing) {
	inputIpping.val(ipPing);
	buttonSubmitp.click();
}

$(function () {
	form.on('submit', function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		buttonSubmitp.click();
	});

	buttonSubmitp.on('click', function () {
		buttonSubmitp.hide(); //bring back load more button
		buttonLoaderp.show();
		buttonLoaderp.fadeIn(400).html('<button class="btn btn-danger" disabled><span class="spinner-grow spinner-grow-sm"></span>	Pingen..</button>');


		$.ajax({
			type: "POST",
			url: "/inc/ping.php",
			data: $("#ipping").serialize(),
			beforeSend: function(XMLHttpRequest){
				$("#flashipping").css('display','inline');
				$('#resultsping').empty();	
			}, 
			cache: false,
			success: function (data) {
				$("ol#resultsping").prepend(data);
				$("ol#resultsping li:first").slideDown("slow");
				buttonLoaderp.hide();
				buttonSubmitp.show();
			}
		});

		return false;
	});
});